import React, { useContext } from 'react';
import LocaleContext from 'constants/localization';

export default function DecimalDisplay({value}) {
  const LS = useContext(LocaleContext);
  const lang = LS.getLanguage();
  if(lang === 'fi' || lang === 'sv'){
	value = value.replaceAll(".",",");
  }
  if(lang === 'en'){
	value = value.replaceAll(",",".");
  }
  return <span className="literal-value">{value}</span>;
}